import styled, { keyframes } from "styled-components";

const scrollText = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-800px); }
`;

export const BannerWrapper = styled.div`
  width: 100%;
  background-color: var(--orange-500);
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  padding: 12px 0;
  overflow: hidden;
  transform: rotate(-3.5deg);
  position: absolute;
`;

export const BannerContent = styled.div`
  display: flex;
  width: 200%;
  animation: ${scrollText} 20s linear infinite; 
  gap: 22px;
`;

export const BannerText = styled.span`
  white-space: nowrap;
`;
